export default "__VITE_ASSET__e2354e5f__"